import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "floating-menu" }

import { computed, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import {
  PPTTextElement,
} from '@/types/slides'
import emitter, { EmitterEvents } from '@/utils/emitter'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import TextColorButton from '../Toolbar/common/TextColorButton.vue'
import CheckboxButton from '@/components/CheckboxButton.vue'
// import CheckboxButtonGroup from '@/components/CheckboxButtonGroup.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import ElementOutline from '../Toolbar/common/ElementOutline.vue'
import {
  AlignTextLeft,
  AlignTextCenter,
  AlignTextRight,
  FontSize,
  TextBold,
  TextItalic,
  TextUnderline,
  Strikethrough,
  Fill,
  HighLight,
} from '@icon-park/vue-next'
import {
  Button,
  Tooltip,
  Popover,
  Select,
  Radio,
  Menu,
  Dropdown,
} from 'ant-design-vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'FloatingMenuContent',
  setup(__props) {

const { Group: RadioGroup, Button: RadioButton } = Radio
const { OptGroup: SelectOptGroup, Option: SelectOption } = Select
const ButtonGroup = Button.Group
const MenuItem = Menu.Item

const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { handleElement, handleElementId, richTextAttrs, editorAreaFocus } =
  storeToRefs(mainStore)
const { currentSlide, slideIndex, slides } = storeToRefs(useSlidesStore())
const themeColor = computed(() => slidesStore.theme.themeColor)

const fill = ref<string>('#000')
const lineHeight = ref<number>()
const wordSpace = ref<number>()
const textIndent = ref<number>()
const paragraphSpace = ref<number>()

watch(
  handleElement,
  () => {
    if (!handleElement.value || handleElement.value.type !== 'text') return

    fill.value = handleElement.value.fill || '#fff'
    lineHeight.value = handleElement.value.lineHeight || 1.5
    wordSpace.value = handleElement.value.wordSpace || 0
    textIndent.value = handleElement.value.textIndent || 0
    paragraphSpace.value =
      handleElement.value.paragraphSpace === undefined
        ? 5
        : handleElement.value.paragraphSpace
  },
  { deep: true, immediate: true }
)

const fontSizeOptions = [
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '22px',
  '24px',
  '28px',
  '32px',
]

const textAttrs = ref({
  bold: false,
  em: false,
  underline: false,
  strikethrough: false,
  color: '#000',
  backcolor: '',
  fontsize: '12px',
  fontname: '微软雅黑',
  align: 'left',
})

const { addHistorySnapshot } = useHistorySnapshot()

const updateElement = (props: Partial<PPTTextElement>) => {
  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}

// 设置文本框填充
const updateFill = (value: string) => {
  updateElement({ fill: value })
}

// 发射富文本设置命令
const emitRichTextCommand = (command: string, value?: string) => {
  // debugger
  // console.log(richTextAttrs)
  emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { action: { command, value } })
}

// 添加按钮点击监听, 点击后向父页面发送消息
// document.getElementById('btn-ai')?.addEventListener('click', () => {
//   window.parent.postMessage({ action: 'AIClicked' }, '*')
// })

const onAIClick = (value?: string) => {
  // debugger
  // console.log('onAIClick', value)

  // 获取选中文字
  emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, {
    action: { command: 'AIClicked', value },
  })
  // console.log('text', text)
  // window.parent.postMessage({ action: value }, '*')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ButtonGroup), { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Popover), { trigger: "click" }, {
          content: _withCtx(() => [
            _createVNode(ColorPicker, {
              modelValue: _unref(richTextAttrs).color,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emitRichTextCommand('color', value))
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Tooltip), {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "文字颜色"
            }, {
              default: _withCtx(() => [
                _createVNode(TextColorButton, {
                  color: _unref(richTextAttrs).color,
                  style: {"flex":"3"}
                }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode(" T ")
                  ])),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(Popover), { trigger: "click" }, {
          content: _withCtx(() => [
            _createVNode(ColorPicker, {
              modelValue: _unref(richTextAttrs).backcolor,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = 
              (value) => emitRichTextCommand('backcolor', value)
            )
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Tooltip), {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "文字高亮"
            }, {
              default: _withCtx(() => [
                _createVNode(TextColorButton, {
                  color: _unref(richTextAttrs).backcolor,
                  style: {"flex":"3"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(HighLight))
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(Popover), { trigger: "click" }, {
          content: _withCtx(() => [
            _createVNode(ColorPicker, {
              modelValue: fill.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => updateFill(value))
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _createVNode(TextColorButton, {
              color: fill.value,
              style: {"flex":"3"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Tooltip), {
                  mouseLeaveDelay: 0,
                  mouseEnterDelay: 0.5,
                  title: "背景填充"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Fill))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["color"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "增大字号"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              class: "font-size-btn",
              style: {"flex":"2"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emitRichTextCommand('fontsize-add')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FontSize)),
                _cache[16] || (_cache[16] = _createTextVNode("+ "))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "减小字号"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              class: "font-size-btn",
              style: {"flex":"2"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (emitRichTextCommand('fontsize-reduce')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FontSize)),
                _cache[17] || (_cache[17] = _createTextVNode("- "))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "加粗"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).bold,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (emitRichTextCommand('bold')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TextBold))
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "斜体"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).em,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (emitRichTextCommand('em')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TextItalic))
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "下划线"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).underline,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (emitRichTextCommand('underline')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(TextUnderline))
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "删除线"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).strikethrough,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (emitRichTextCommand('strikethrough')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Strikethrough))
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "左对齐"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).align === 'left',
              onClick: _cache[9] || (_cache[9] = ($event: any) => (emitRichTextCommand('align', 'left')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(AlignTextLeft))
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "居中"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).align === 'center',
              onClick: _cache[10] || (_cache[10] = ($event: any) => (emitRichTextCommand('align', 'center')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(AlignTextCenter))
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "右对齐"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: _unref(richTextAttrs).align === 'right',
              onClick: _cache[11] || (_cache[11] = ($event: any) => (emitRichTextCommand('align', 'right')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(AlignTextRight))
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Dropdown), {
      trigger: ['click'],
      placement: "topRight"
    }, {
      overlay: _withCtx(() => [
        _createVNode(ElementOutline)
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Button), null, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [
            _createTextVNode("边框")
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(Dropdown), {
      trigger: ['click'],
      placement: "topRight"
    }, {
      overlay: _withCtx(() => [
        _createVNode(_unref(Menu), null, {
          default: _withCtx(() => [
            _createVNode(_unref(MenuItem), {
              key: "1",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (onAIClick('AIRewrite')))
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createTextVNode("改写")
              ])),
              _: 1
            }),
            _createVNode(_unref(MenuItem), {
              key: "2",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (onAIClick('AIExtension')))
            }, {
              default: _withCtx(() => _cache[20] || (_cache[20] = [
                _createTextVNode("扩写")
              ])),
              _: 1
            }),
            _createVNode(_unref(MenuItem), {
              key: "3",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (onAIClick('AIAbbreviation')))
            }, {
              default: _withCtx(() => _cache[21] || (_cache[21] = [
                _createTextVNode("缩写")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "btn-ai",
          id: "btn-ai"
        }, "AI", -1))
      ]),
      _: 1
    })
  ]))
}
}

})